import { httpReq, httpReqAuth } from "./axios";

export const httpLoginPost = (params) => httpReqAuth.post('/api/auth/login', params)

export const httpGetContacts = (params) => httpReq.get('/api/contacts', params)
export const httpGetByIdContact = (id) => httpReq.get(`/api/contacts/${id}`)
export const httpPostContact = (params) => httpReq.post('/api/contacts/create', params)
export const httpPutContact = (params) => httpReq.put('/api/contacts', params)
export const httpDeleteContact = (id) => httpReq.delete(`/api/contacts/${id}`)